<template>
  <div class="card mb-12" style="min-height: 60vh; border: none;">
    <div class="col-md-12">
      <h6 class="heading-small text-muted mb-4 text-truncate">Configuration History - {{ documentName }}</h6>
    </div>

    <div class="mb-12">
      <a-spin :tip="spinMessage" :spinning="spinning">
      <div class="col-lg-12">
        <div class="card-body">
          <div>
            <h6 class="heading-small text-muted mb-4">Date Range</h6>
            <base-input alternative="">
              <a-range-picker v-model="dateRange"
                              format="MM-DD-YYYY"
                              :placeholder="['Start Date', 'End Date']"
                              style="width:100%"/>
            </base-input>
          </div>

          <div>
            <h6 class="heading-small text-muted mb-4">Configuration</h6>
            <a-select style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="selectedConfig" :disabled="disableConfigType">
              <a-select-option v-for="config in configs" :key="config.id" :value="config.id">{{config.name}}</a-select-option>
            </a-select>
          </div>
          <br>
          <div>
            <a-button type="primary"
                      size="large"
                      class="btn btn-primary float-right"
                      @click.prevent="getData">
              Filter
            </a-button>
          </div>
        </div>
      </div>
      <br>
      <div class="col-lg-12">
        <div class="card-body">
          <div class="table-responsive" >
            <vuetable v-if="tableURL.length > 0"
                      ref="vuetable"
                      :api-url="tableURL"
                      :http-options="httpOptions"
                      :fields="fields"
                      :show-sort-icons="true"
                      :per-page="10"
                      :css="tableCSS.table"
                      pagination-path=""
                      data-path="data"
                      no-data-template="Empty"
                      @vuetable:load-error="onLoadError"
                      @vuetable:pagination-data="onPaginationData"/>
          </div>

          <div class="card-footer d-flex justify-content-end bg-transparent">
            <div class="pagination ui basic segment grid">
              <vuetable-pagination
                ref="pagination"
                @vuetable-pagination:change-page="onChangePage"
                :css="tableCSS.pagination">
              </vuetable-pagination>
            </div>
          </div>
        </div>
      </div>
    </a-spin>
    </div>
  </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest.js';
import { mapState } from 'vuex';
import secureStorage from '../../controllers/secureStorage';
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import { sortAlphabetical } from '../../utilities';
import moment from 'moment';

export default {
  components: {
    Vuetable,
    VuetablePagination
  },
  computed: {
    ...mapState(['endPoint', 'profileId', 'serverType']),
  },

  data() {
    return {
      disableConfigType: false,
      spinning: false,
      spinMessage: 'Fetching Data.....',
      documentName: '',
      documentCode: '',
      selectedConfig: '',
      configs_document: [
        { id: 'priceOrCost', name: 'Price or Cost'},
        { id: 'editorBehavior', name: 'Editor Behavior'},
        { id: 'additionalEditorBehaviorCheckboxes', name: 'Additional Editor Behavior Checkboxes'},
        { id: 'additionalEditorBehavior', name: 'Additional Editor Behavior'},
        { id: 'printSettings', name: 'Print Settings'},
        { id: 'incomingOrder', name: 'Incoming Order'},
        { id: 'outgoingOrder', name: 'Outgoing Order'},
        { id: 'receivingDocument', name: 'Receiving Document'},
        { id: 'receivingDocumentWithOrder', name: 'Receiving Document With Order'},
        { id: 'releasingDocument', name: 'Releasing Document'},
        { id: 'releasingDocumentWithOrder', name: 'Releasing Document With Order'},
        { id: 'transferDocument', name: 'Transfer Document'},
        { id: 'orderSource', name: 'Order Source'},
        { id: 'customerReturn', name: 'Customer Return'}
      ],
      configs_product: [
        { id: 'UserSettings_General', name: 'User Settings / General'},
        { id: 'UserSettings_Warnings', name: 'User Settings / Warnings'},
        { id: 'UserSettings_Fields', name: 'User Settings / Fields'},
        { id: 'GlobalSettings_General', name: 'Global Settings / General'},
        { id: 'GlobalSettings_Product Editor', name: 'Global Settings / Product Editor'},
        { id: 'GlobalSettings_Plug-ins', name: 'Global Settings / Plug-ins'}
      ],
      configs: [],
      dateRange: [moment().startOf('day'), moment().endOf('day')],
      fields: [
        {name: "config", title: "Configuration"},
        {name: "config_type", title: "Type"},
        {name: "config_from", title: "From"},
        {name: "config_to", title: "To"},
        {name: "config_by", title: "By"},
        {name: "config_at", title: "Date"}
      ],
      httpOptions: {
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
        }
      },
      tableURL: '',
      tableCSS: {
        table: {
          tableClass: 'table table-sm table-striped table-bordered table-hovered',
          loadingClass: 'loading'
        },
        pagination: {
          infoClass: 'pull-right',
          wrapperClass: 'vuetable-pagination pull-right',
          activeClass: 'btn-primary btn-sm',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        }
      },
      tableData: []
    }
  },

  mounted: async function() {
    this.tableURL = await `${this.endPoint}document_configuration_histories/config_histories`;
    if(secureStorage.getItem("documentTypeId") == -1) {
      this.documentName = 'Promotion Management'
      this.documentCode = -1
      this.disableConfigType = true
    } else if (secureStorage.getItem("documentTypeId") == -2) {
      this.documentName = 'Product Management'
      this.documentCode = -2
      this.configs = this.configs_product
      this.disableConfigType = false
    } else if (secureStorage.getItem("documentTypeId") == -3) {
      this.documentName = 'Sales Channel Management'
      this.documentCode = -3
      this.disableConfigType = true
    } else {
      var data = await HTTPRequest.getRequest(this.endPoint+'/document_types?id='+ secureStorage.getItem("documentTypeId"), null)
        if (data[0] != undefined) {
          this.documentName = data[0].name
          this.documentCode = data[0].type_code
      }
      this.configs = this.configs_document
      this.disableConfigType = false
    }
    
  },
  methods: {
    getData: async function() {
      this.spinning = true
      let tableURL = `${this.endPoint}document_configuration_histories/config_histories?`;
      tableURL += `config_account=${secureStorage.getItem("accountId")}`; 
      tableURL += `&config=${this.selectedConfig}`;
      tableURL += `&document_type=${secureStorage.getItem("documentTypeId")}`;
      tableURL += `&config_at_from=${this.dateRange[0].format('YYYY-MM-DD')}`;
      tableURL += `&config_at_to=${this.dateRange[1].format('YYYY-MM-DD')}`;

      this.tableURL = tableURL
      this.spinning = false
    },

    onLoadError: async function(error) {
      console.log(error)
    },

    onPaginationData: async function(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },

    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
  }
}
</script>